import { render, staticRenderFns } from "./Dynamic-Form.vue?vue&type=template&id=e4512b56&"
import script from "./Dynamic-Form.vue?vue&type=script&lang=js&"
export * from "./Dynamic-Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports